import { headers } from './constants';
import axios from 'axios';
import { SCENARIO_BASE_URL } from 'constants/api';
import queryString from 'query-string';

export const scenarioOneAPI = {
    fetchStats: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/stats?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchOutliersData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/outliers?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchTrendData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/trend?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchPortfolioData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/portfolios?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data)
};
